/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumChatActivityReason = "noFurtherAction" | "notActionable" | "notRelevant" | "offensive" | "other" | "spam" | "%future added value";
export type EnumChatActivityStatus = "assigned" | "closed" | "pending" | "unassigned" | "%future added value";
export type FilterChatActivityInput = {
    user?: string | null | undefined;
    _id?: string | null | undefined;
    deleted?: number | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    createdBy?: string | null | undefined;
    updatedBy?: string | null | undefined;
    deletedBy?: string | null | undefined;
    deletedAt?: unknown | null | undefined;
    to?: string | null | undefined;
    patient?: string | null | undefined;
    lastMessage?: string | null | undefined;
    unreadMessages?: number | null | undefined;
    status?: EnumChatActivityStatus | null | undefined;
    assignee?: string | null | undefined;
    groupAssignee?: string | null | undefined;
    previousAssignee?: string | null | undefined;
    previousGroupAssignee?: string | null | undefined;
    reason?: EnumChatActivityReason | null | undefined;
    statusReason?: unknown | null | undefined;
    description?: string | null | undefined;
    facilities?: Array<string | null> | null | undefined;
    priorityUpdatedAt?: unknown | null | undefined;
    lastIrregularAt?: unknown | null | undefined;
    automated?: boolean | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterChatActivityInput | null | undefined;
    OR?: Array<FilterChatActivityInput> | null | undefined;
    AND?: Array<FilterChatActivityInput> | null | undefined;
};
export type OperatorsFilterChatActivityInput = {
    user?: UserOperatorsFilterChatActivityInput | null | undefined;
    _id?: _idOperatorsFilterChatActivityInput | null | undefined;
    deleted?: DeletedOperatorsFilterChatActivityInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterChatActivityInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterChatActivityInput | null | undefined;
    createdBy?: CreatedByOperatorsFilterChatActivityInput | null | undefined;
    updatedBy?: UpdatedByOperatorsFilterChatActivityInput | null | undefined;
    deletedBy?: DeletedByOperatorsFilterChatActivityInput | null | undefined;
    deletedAt?: DeletedAtOperatorsFilterChatActivityInput | null | undefined;
    to?: ToOperatorsFilterChatActivityInput | null | undefined;
    patient?: PatientOperatorsFilterChatActivityInput | null | undefined;
    lastMessage?: LastMessageOperatorsFilterChatActivityInput | null | undefined;
    unreadMessages?: UnreadMessagesOperatorsFilterChatActivityInput | null | undefined;
    status?: StatusOperatorsFilterChatActivityInput | null | undefined;
    assignee?: AssigneeOperatorsFilterChatActivityInput | null | undefined;
    groupAssignee?: GroupAssigneeOperatorsFilterChatActivityInput | null | undefined;
    previousAssignee?: PreviousAssigneeOperatorsFilterChatActivityInput | null | undefined;
    previousGroupAssignee?: PreviousGroupAssigneeOperatorsFilterChatActivityInput | null | undefined;
    reason?: ReasonOperatorsFilterChatActivityInput | null | undefined;
    statusReason?: StatusReasonOperatorsFilterChatActivityInput | null | undefined;
    description?: DescriptionOperatorsFilterChatActivityInput | null | undefined;
    facilities?: FacilitiesOperatorsFilterChatActivityInput | null | undefined;
    priorityUpdatedAt?: PriorityUpdatedAtOperatorsFilterChatActivityInput | null | undefined;
    lastIrregularAt?: LastIrregularAtOperatorsFilterChatActivityInput | null | undefined;
    automated?: AutomatedOperatorsFilterChatActivityInput | null | undefined;
};
export type UserOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type _idOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedOperatorsFilterChatActivityInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type CreatedAtOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type CreatedByOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UpdatedByOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedByOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedAtOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type ToOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PatientOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type LastMessageOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UnreadMessagesOperatorsFilterChatActivityInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type StatusOperatorsFilterChatActivityInput = {
    gt?: EnumChatActivityStatus | null | undefined;
    gte?: EnumChatActivityStatus | null | undefined;
    lt?: EnumChatActivityStatus | null | undefined;
    lte?: EnumChatActivityStatus | null | undefined;
    ne?: EnumChatActivityStatus | null | undefined;
    in?: Array<EnumChatActivityStatus | null> | null | undefined;
    nin?: Array<EnumChatActivityStatus | null> | null | undefined;
    regex?: EnumChatActivityStatus | null | undefined;
};
export type AssigneeOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type GroupAssigneeOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PreviousAssigneeOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PreviousGroupAssigneeOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ReasonOperatorsFilterChatActivityInput = {
    gt?: EnumChatActivityReason | null | undefined;
    gte?: EnumChatActivityReason | null | undefined;
    lt?: EnumChatActivityReason | null | undefined;
    lte?: EnumChatActivityReason | null | undefined;
    ne?: EnumChatActivityReason | null | undefined;
    in?: Array<EnumChatActivityReason | null> | null | undefined;
    nin?: Array<EnumChatActivityReason | null> | null | undefined;
    regex?: EnumChatActivityReason | null | undefined;
};
export type StatusReasonOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type DescriptionOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FacilitiesOperatorsFilterChatActivityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PriorityUpdatedAtOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type LastIrregularAtOperatorsFilterChatActivityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type AutomatedOperatorsFilterChatActivityInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type QueryListChatActivityAssignees_EmbedQueryVariables = {
    regex?: string | null | undefined;
    includeAvatar?: boolean | null | undefined;
    includeEmail?: boolean | null | undefined;
    includeChatActivityCount?: boolean | null | undefined;
    filterChatActivityCount?: FilterChatActivityInput | null | undefined;
};
export type QueryListChatActivityAssignees_EmbedQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"ListChatActivityAssignees_EmbedQuery">;
};
export type QueryListChatActivityAssignees_EmbedQuery = {
    readonly response: QueryListChatActivityAssignees_EmbedQueryResponse;
    readonly variables: QueryListChatActivityAssignees_EmbedQueryVariables;
};



/*
query QueryListChatActivityAssignees_EmbedQuery(
  $regex: String = ""
  $includeAvatar: Boolean = false
  $includeEmail: Boolean = false
  $includeChatActivityCount: Boolean = false
  $filterChatActivityCount: FilterChatActivityInput
) {
  ...ListChatActivityAssignees_EmbedQuery_1UkeHV
}

fragment AvatarNode_EmbedNode on Node {
  __isNode: __typename
  __typename
  ... on Group {
    groupName: name
  }
  ... on Patient {
    name
    oid_avatar
    isOnline
  }
  ... on Provider {
    name
    oid_avatar
    isOnline
  }
  ... on User {
    name
    oid_avatar
    isOnline
  }
  ... on ChatActivity {
    patient {
      name
      oid_avatar
      isOnline
      id
    }
  }
}

fragment ListChatActivityAssignees_EmbedQuery_1UkeHV on Query {
  viewer {
    _id
    ...ListItemAssignee_EmbedNode_2wrdSw
    id
  }
  userMany(sort: NAME_ASC, filter: {type: staff, active: 1, _operators: {name: {regex: $regex}, roles: {ne: "widget"}}}) {
    _id
    ...ListItemAssignee_EmbedNode_2wrdSw
    id
  }
  groupMany(sort: NAME_ASC, filter: {_operators: {name: {regex: $regex}, type: {ne: system}}}) {
    _id
    ...ListItemAssignee_EmbedNode_3uIqSI
    id
  }
  providerConnection(first: 15, sort: NAME_ASC, filter: {active: 1, isRenderingProvider: true, visible: true, _operators: {name: {regex: $regex}}}) {
    edges {
      node {
        _id
        ...ListItemAssignee_EmbedNode_2wrdSw
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ListItemAssignee_EmbedNode_2wrdSw on Node {
  __isNode: __typename
  ...ListItemNode_EmbedNode_hwDuA
  ... on Group {
    ...TypographyNodeName_EmbedNode
    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)
  }
  ... on User {
    ...TypographyNodeName_EmbedNode
    email @include(if: $includeEmail)
    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)
  }
  ... on Provider {
    ...TypographyNodeName_EmbedNode
    email @include(if: $includeEmail)
    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)
  }
}

fragment ListItemAssignee_EmbedNode_3uIqSI on Node {
  __isNode: __typename
  ...ListItemNode_EmbedNode_hwDuA
  ... on Group {
    ...TypographyNodeName_EmbedNode
    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)
  }
  ... on User {
    ...TypographyNodeName_EmbedNode
    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)
  }
  ... on Provider {
    ...TypographyNodeName_EmbedNode
    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)
  }
}

fragment ListItemNode_EmbedNode_hwDuA on Node {
  __isNode: __typename
  __typename
  id
  ... on User {
    ...AvatarNode_EmbedNode @include(if: $includeAvatar)
    name
  }
  ... on Provider {
    ...AvatarNode_EmbedNode @include(if: $includeAvatar)
    name
  }
  ... on Patient {
    ...AvatarNode_EmbedNode @include(if: $includeAvatar)
    name
  }
  ... on Group {
    ...AvatarNode_EmbedNode @include(if: $includeAvatar)
    groupName: name
  }
  ... on Audit {
    ...AvatarNode_EmbedNode @include(if: $includeAvatar)
    nameJson: new
  }
}

fragment TypographyNodeName_EmbedNode on Node {
  __isNode: __typename
  ... on Group {
    groupName: name
  }
  ... on Patient {
    name
  }
  ... on Provider {
    name
  }
  ... on User {
    name
  }
  ... on Facility {
    facilityName: name
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterChatActivityCount"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAvatar"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeChatActivityCount"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeEmail"
},
v4 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "regex"
},
v5 = {
  "kind": "Variable",
  "name": "regex",
  "variableName": "regex"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": "groupName",
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/)
  ],
  "type": "Group",
  "abstractKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_avatar",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOnline",
  "storageKey": null
},
v14 = [
  (v12/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Patient",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Provider",
  "abstractKey": null
},
v17 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "User",
  "abstractKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Patient",
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ChatActivity",
  "abstractKey": null
},
v19 = {
  "condition": "includeAvatar",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v11/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/)
      ],
      "type": "Node",
      "abstractKey": "__isNode"
    }
  ]
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "facilityName",
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    (v20/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v22 = {
  "condition": "includeChatActivityCount",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filterChatActivityCount"
        }
      ],
      "kind": "ScalarField",
      "name": "chatActivityCount",
      "storageKey": null
    }
  ]
},
v23 = [
  (v9/*: any*/),
  (v19/*: any*/),
  (v21/*: any*/),
  {
    "condition": "includeEmail",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      }
    ]
  },
  (v22/*: any*/)
],
v24 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "User",
  "abstractKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "Provider",
  "abstractKey": null
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v19/*: any*/)
  ],
  "type": "Patient",
  "abstractKey": null
},
v27 = {
  "condition": "includeAvatar",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/)
      ],
      "type": "Node",
      "abstractKey": "__isNode"
    }
  ]
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v27/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v20/*: any*/)
      ],
      "type": "Node",
      "abstractKey": "__isNode"
    },
    (v22/*: any*/)
  ],
  "type": "Group",
  "abstractKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "nameJson",
      "args": null,
      "kind": "ScalarField",
      "name": "new",
      "storageKey": null
    },
    (v27/*: any*/)
  ],
  "type": "Audit",
  "abstractKey": null
},
v30 = [
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v8/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v31 = {
  "fields": [
    (v5/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "name"
},
v32 = {
  "kind": "Literal",
  "name": "active",
  "value": 1
},
v33 = {
  "kind": "Literal",
  "name": "sort",
  "value": "NAME_ASC"
},
v34 = [
  (v9/*: any*/),
  (v19/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v35 = [
  {
    "fields": [
      {
        "fields": [
          (v31/*: any*/)
        ],
        "kind": "ObjectValue",
        "name": "_operators"
      },
      (v32/*: any*/),
      {
        "kind": "Literal",
        "name": "isRenderingProvider",
        "value": true
      },
      {
        "kind": "Literal",
        "name": "visible",
        "value": true
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 15
  },
  (v33/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QueryListChatActivityAssignees_EmbedQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "filterChatActivityCount",
            "variableName": "filterChatActivityCount"
          },
          {
            "kind": "Variable",
            "name": "includeAvatar",
            "variableName": "includeAvatar"
          },
          {
            "kind": "Variable",
            "name": "includeChatActivityCount",
            "variableName": "includeChatActivityCount"
          },
          {
            "kind": "Variable",
            "name": "includeEmail",
            "variableName": "includeEmail"
          },
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ListChatActivityAssignees_EmbedQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "QueryListChatActivityAssignees_EmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": (v30/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "fields": [
                  (v31/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "roles",
                    "value": {
                      "ne": "widget"
                    }
                  }
                ],
                "kind": "ObjectValue",
                "name": "_operators"
              },
              (v32/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "staff"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v33/*: any*/)
        ],
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "userMany",
        "plural": true,
        "selections": (v30/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "fields": [
                  (v31/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": {
                      "ne": "system"
                    }
                  }
                ],
                "kind": "ObjectValue",
                "name": "_operators"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v33/*: any*/)
        ],
        "concreteType": "Group",
        "kind": "LinkedField",
        "name": "groupMany",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v34/*: any*/),
                "type": "User",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v34/*: any*/),
                "type": "Provider",
                "abstractKey": null
              },
              (v26/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v35/*: any*/),
        "concreteType": "ProviderConnection",
        "kind": "LinkedField",
        "name": "providerConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProviderEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Provider",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v35/*: any*/),
        "filters": [
          "sort",
          "filter"
        ],
        "handle": "connection",
        "key": "ListChatActivityAssignees_providerConnection",
        "kind": "LinkedHandle",
        "name": "providerConnection"
      }
    ]
  },
  "params": {
    "cacheID": "7c345dd4031f4a8dfc957a674ff63deb",
    "id": null,
    "metadata": {},
    "name": "QueryListChatActivityAssignees_EmbedQuery",
    "operationKind": "query",
    "text": "query QueryListChatActivityAssignees_EmbedQuery(\n  $regex: String = \"\"\n  $includeAvatar: Boolean = false\n  $includeEmail: Boolean = false\n  $includeChatActivityCount: Boolean = false\n  $filterChatActivityCount: FilterChatActivityInput\n) {\n  ...ListChatActivityAssignees_EmbedQuery_1UkeHV\n}\n\nfragment AvatarNode_EmbedNode on Node {\n  __isNode: __typename\n  __typename\n  ... on Group {\n    groupName: name\n  }\n  ... on Patient {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on Provider {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on User {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on ChatActivity {\n    patient {\n      name\n      oid_avatar\n      isOnline\n      id\n    }\n  }\n}\n\nfragment ListChatActivityAssignees_EmbedQuery_1UkeHV on Query {\n  viewer {\n    _id\n    ...ListItemAssignee_EmbedNode_2wrdSw\n    id\n  }\n  userMany(sort: NAME_ASC, filter: {type: staff, active: 1, _operators: {name: {regex: $regex}, roles: {ne: \"widget\"}}}) {\n    _id\n    ...ListItemAssignee_EmbedNode_2wrdSw\n    id\n  }\n  groupMany(sort: NAME_ASC, filter: {_operators: {name: {regex: $regex}, type: {ne: system}}}) {\n    _id\n    ...ListItemAssignee_EmbedNode_3uIqSI\n    id\n  }\n  providerConnection(first: 15, sort: NAME_ASC, filter: {active: 1, isRenderingProvider: true, visible: true, _operators: {name: {regex: $regex}}}) {\n    edges {\n      node {\n        _id\n        ...ListItemAssignee_EmbedNode_2wrdSw\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ListItemAssignee_EmbedNode_2wrdSw on Node {\n  __isNode: __typename\n  ...ListItemNode_EmbedNode_hwDuA\n  ... on Group {\n    ...TypographyNodeName_EmbedNode\n    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)\n  }\n  ... on User {\n    ...TypographyNodeName_EmbedNode\n    email @include(if: $includeEmail)\n    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)\n  }\n  ... on Provider {\n    ...TypographyNodeName_EmbedNode\n    email @include(if: $includeEmail)\n    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)\n  }\n}\n\nfragment ListItemAssignee_EmbedNode_3uIqSI on Node {\n  __isNode: __typename\n  ...ListItemNode_EmbedNode_hwDuA\n  ... on Group {\n    ...TypographyNodeName_EmbedNode\n    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)\n  }\n  ... on User {\n    ...TypographyNodeName_EmbedNode\n    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)\n  }\n  ... on Provider {\n    ...TypographyNodeName_EmbedNode\n    chatActivityCount(filter: $filterChatActivityCount) @include(if: $includeChatActivityCount)\n  }\n}\n\nfragment ListItemNode_EmbedNode_hwDuA on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on User {\n    ...AvatarNode_EmbedNode @include(if: $includeAvatar)\n    name\n  }\n  ... on Provider {\n    ...AvatarNode_EmbedNode @include(if: $includeAvatar)\n    name\n  }\n  ... on Patient {\n    ...AvatarNode_EmbedNode @include(if: $includeAvatar)\n    name\n  }\n  ... on Group {\n    ...AvatarNode_EmbedNode @include(if: $includeAvatar)\n    groupName: name\n  }\n  ... on Audit {\n    ...AvatarNode_EmbedNode @include(if: $includeAvatar)\n    nameJson: new\n  }\n}\n\nfragment TypographyNodeName_EmbedNode on Node {\n  __isNode: __typename\n  ... on Group {\n    groupName: name\n  }\n  ... on Patient {\n    name\n  }\n  ... on Provider {\n    name\n  }\n  ... on User {\n    name\n  }\n  ... on Facility {\n    facilityName: name\n  }\n}\n"
  }
};
})();
(node as any).hash = '7389c722512e8051edd3bf83d352f890';
export default node;
